import React from 'react';
import { defineMessages } from 'react-intl';

import Message from 'components/Message';

import './InstructorsListEmpty.scss';

const messages = defineMessages({
  title: {
    id: 'instructors-list-empty.title',
    defaultMessage: 'No staff added yet',
  },
  subtitle: {
    id: 'instructors-list-empty.subtitle',
    defaultMessage: 'Add your first staff to get started',
  },
});

const InstructorsListEmpty = () => (
  <div className="instructors-list-empty" data-cypress="instructors-list-empty">
    <Message as="p" message={messages.title} />
    <Message as="p" message={messages.subtitle} />
  </div>
);

InstructorsListEmpty.propTypes = {};

export default InstructorsListEmpty;
